module.exports = "/_next/static/images/unlock-4cb7653fd8486aa36c85e47b07232e21.png";